import "reflect-metadata";
import "smelte/src/tailwind.css";
import App from "./app/app.svelte";

new App({
  target: document.body,
});
